import React, { createContext, useContext, ReactNode } from 'react';
import { useOptimizationJob } from '@/hooks/useOptimizationJob';

type OptimizationValue = ReturnType<typeof useOptimizationJob>;

const OptimizationContext = createContext<OptimizationValue | undefined>(undefined);

export function useOptimization(): OptimizationValue {
  const ctx = useContext(OptimizationContext);
  if (!ctx) {
    throw new Error('useOptimization must be used within OptimizationProvider');
  }
  return ctx;
}

interface ProviderProps {
  feedId: string | null;
  feedProductCount: number;
  children: ReactNode;
}

export function OptimizationProvider({ feedId, feedProductCount, children }: ProviderProps) {
  const value = useOptimizationJob(feedId, feedProductCount);
  return (
    <OptimizationContext.Provider value={value}>
      {children}
    </OptimizationContext.Provider>
  );
}
